<!-- ColumnManagerDialog.vue -->
<template>
  <v-dialog v-model="isOpen" width="700" persistent>
    <v-card>
      <div class="dialog-header">
        <span>چیدمان ستون‌های جدول</span>
        <v-icon color="#fff" @click="close">mdi-close</v-icon>
      </div>

      <div class="dialog-body">
        <div class="section-title" v-if="fixedColumns?.length > 0">
          <v-icon size="16" color="#98a0b3">mdi-lock-outline</v-icon>
          ستون‌های ثابت
          <span class="section-title__hint">همیشه در همین جایگاه می‌مانند</span>
        </div>
        <div class="fixed-columns" v-if="fixedColumns?.length > 0">
          <div v-for="col in fixedColumns" :key="col.value" class="column-item column-item--fixed">
            <v-icon color="#b3b9c6" size="16">mdi-lock-outline</v-icon>
            <span>{{ col.text }}</span>
          </div>
        </div>

        <div class="section-title">
          <v-icon size="16" color="#17337e">mdi-swap-vertical</v-icon>
          نمایش و ترتیب ستون‌ها
          <span class="section-title__hint">با کشیدن (drag) جابجا میشود</span>
          <v-spacer />
          <!-- <span class="section-title__count">
            {{ toPersianDigits(activeCount) }} از {{ toPersianDigits(movableColumns.length) }} فعال
          </span> -->
        </div>

        <draggable v-model="movableColumns" tag="div" class="movable-columns" handle=".dragClick"
          ghost-class="column-item--ghost" chosen-class="column-item--chosen" animation="180">
          <div v-for="(col, index) in movableColumns" :key="col.value" class="column-item"
            :class="{ 'column-item--inactive': !col.isActive }">
            <v-icon class="column-item__handle dragClick" color="#c3c9d6" size="20">mdi-drag-vertical</v-icon>
            <!-- <v-checkbox v-model="col.isActive" class="column-item__checkbox" hide-details dense color="#17337e"
              @click.stop></v-checkbox> -->
            <span class="column-item__index dragClick">{{ toPersianDigits(index + 1) }}</span>
            <span class="column-item__text dragClick">{{ col.text }}</span>

            <span>طول : </span>
            <v-text-field v-model.number="col.width" class="column-item__width" type="number" dense hide-details
              outlined suffix="px" placeholder="عرض" min="40" max="600" />

            <div class="column-item__actions">
              <v-btn icon x-small :disabled="index === 0" @click="moveUp(index)">
                <v-icon color="#9aa3b8" size="16">mdi-chevron-up</v-icon>
              </v-btn>
              <v-btn icon x-small :disabled="index === movableColumns.length - 1" @click="moveDown(index)">
                <v-icon color="#9aa3b8" size="16">mdi-chevron-down</v-icon>
              </v-btn>
            </div>
          </div>
        </draggable>

        <div v-if="!movableColumns.length" class="empty-state">
          ستونِ قابل‌جابجایی‌ای وجود ندارد.
        </div>
      </div>

      <div class="dialog-footer">
        <v-btn depressed color="#17337E" dark class="footer-btn" @click="submit">
          <v-icon size="16" left>mdi-check</v-icon>
          ثبت
        </v-btn>
        <v-btn outlined color="#94A3B8" class="footer-btn" @click="close">انصراف</v-btn>
        <v-spacer />
        <v-btn text color="#2A4CA8" class="footer-btn" @click="resetToDefault">
          <v-icon size="16" left>mdi-restore</v-icon>
          بازنشانی به حالت پیش‌فرض
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'ColumnManagerDialog',
  components: { draggable },
  props: {
    value: { type: Boolean, default: false },
    isReverse: { type: Boolean, default: true },
    headers: { type: Array, required: true },
    defaultHeaders: { type: Array, required: true },
    fixedValues: {
      type: Array,
      default: () => ['zone', 'user'],
    },
  },
  data() {
    return {
      movableColumns: [],
    };
  },
  computed: {
    isOpen: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); },
    },
    fixedColumns() {
      return this.headers
        .filter(h => this.fixedValues.includes(h.value));
    },
    activeCount() {
      return this.movableColumns.filter(c => c.isActive).length;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) this.initColumns();
      },
      immediate: true,
    },
  },
  methods: {
    initColumns() {
      const filtered = this.headers
        .filter(h => !this.fixedValues.includes(h.value))
        .map(h => ({
          ...h,
          width: h.width || 120,
          isActive: h.isActive || false
        }))

      this.movableColumns = this.isReverse
        ? filtered.reverse()
        : filtered;

    },

    moveUp(index) {
      if (index === 0) return;
      const item = this.movableColumns.splice(index, 1)[0];
      this.movableColumns.splice(index - 1, 0, item);
    },

    moveDown(index) {
      if (index === this.movableColumns.length - 1) return;
      const item = this.movableColumns.splice(index, 1)[0];
      this.movableColumns.splice(index + 1, 0, item);
    },

    submit() {
      const newHeaders = [
        ...this.fixedColumns,
        ...this.movableColumns,
      ];

      let result;
      if (this.isReverse) {
        result = newHeaders.slice().reverse();
      } else {
        result = newHeaders.slice();
      }
      this.$emit('submit', result);
      this.close();
    },

    resetToDefault() {
      const filtered = this.defaultHeaders
        .filter(h => !this.fixedValues.includes(h.value))
        .map(h => ({
          ...h,
          isActive: true,
          width: h.width || '120px',
        }))

      this.movableColumns = this.isReverse
        ? filtered.reverse()
        : filtered;
    },

    close() {
      this.isOpen = false;
      this.$emit('cancel');
    },

    toPersianDigits(value) {
      const p = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return String(value).replace(/[0-9]/g, d => p[+d]);
    },
  },
};
</script>

<style scoped>
.dialog-header {
  background: #17337e;
  color: #fff;
  padding: 14px 20px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header .v-icon {
  cursor: pointer;
}

.dialog-body {
  padding: 18px 20px;
  max-height: 60vh;
  overflow-y: auto;
}

>>>.v-text-field--outlined fieldset {
  border-color: #d4d4d4;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #5a6379;
  margin: 16px 0 8px;
}

.section-title__hint {
  font-size: 11px;
  font-weight: 400;
  color: #b3b9c6;
}

.section-title__count {
  font-size: 11px;
  font-weight: 400;
  color: #9aa3b8;
}

.fixed-columns,
.movable-columns {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.column-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8fafd;
  border: 1px solid #e3e9f5;
  border-radius: 9px;
  padding: 8px 12px;
  font-size: 12.5px;
  color: #1d2333;
  transition: background 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.column-item:hover {
  background: #f0f5fc;
  border-color: #cfdaf2;
}

.column-item__handle {
  /* cursor: grab; */
  margin-left: 2px;
}

.dragClick {
  cursor: grab;
}

.dragClick:active {
  cursor: grabbing;
}

.column-item__checkbox {
  margin: 0 !important;
  padding: 0 !important;
  flex: none;
}

.column-item__checkbox>>>.v-input__slot {
  margin: 0 !important;
}

.column-item__checkbox>>>.v-messages {
  display: none !important;
}

.column-item--inactive {
  background: #fbfbfc;
  opacity: 0.55;
}

.column-item--inactive .column-item__text {
  text-decoration: line-through;
  text-decoration-color: #c3c9d6;
}

.column-item__width {
  width: 90px;
  min-width: 150px;
  flex-shrink: 0;
  flex: 0 !important;
}

.column-item__width>>>.v-input__slot {
  min-height: 30px !important;
  padding: 0 8px !important;
}

.column-item__width>>>input {
  text-align: center;
  font-size: 12px;
  direction: ltr;
}

.column-item__width>>>.v-input__append-inner {
  margin-top: 6px !important;
}

/* حالتِ آیتمی که الان داره کشیده می‌شه */
.column-item--chosen {
  background: #eef3fd;
  border-color: #9fb4e0;
  box-shadow: 0 4px 14px rgba(23, 51, 126, 0.14);
}

/* جای خالی (placeholder) که نشون می‌ده آیتم کجا رها می‌شه */
.column-item--ghost {
  opacity: 0.4;
  background: #e3e9f5;
}

.column-item--fixed {
  background: #f8f9fb;
  color: #9aa3b8;
  border-style: dashed;
}

.column-item--fixed:hover {
  background: #f8f9fb;
  border-color: #e3e9f5;
}

.column-item__index {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e8effc;
  color: #17337e;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.column-item__text {
  flex: 1;
}

.column-item__actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}

.empty-state {
  text-align: center;
  color: #9aa3b8;
  font-size: 12.5px;
  padding: 20px;
  border: 1px dashed #e3e9f5;
  border-radius: 9px;
}

.dialog-footer {
  padding: 14px 20px;
  border-top: 1px solid #edf0f6;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fcfdfe;
}

.footer-btn {
  text-transform: none;
  font-size: 12.5px;
  font-weight: 500;
  border-radius: 8px;
  box-shadow: none !important;
}
</style>